export default __webpack_public_path__ + "static/media/unordered_list_icon_grey.2ce5686e.svg";